import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode disabled to avoid double-mount issues with some UI libraries in dev preview
  <App />,
);

// Lueur discrète et noble qui suit le curseur
(function initCursorGlow() {
  if (typeof window === "undefined") return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const glow = document.createElement("div");
  glow.id = "padaid-cursor-glow";
  document.body.appendChild(glow);
  let raf = null;
  window.addEventListener("pointermove", (e) => {
    if (raf) return;
    raf = window.requestAnimationFrame(() => {
      glow.style.setProperty("--mx", e.clientX + "px");
      glow.style.setProperty("--my", e.clientY + "px");
      raf = null;
    });
  });
})();
